import { normalizeTextForSearch } from '@/util/greekFilter';

export const createSearchMatcher = (query: string): ((terms: string[]) => boolean) => {
  const trimmed = query.trim();
  if (!trimmed) {
    return () => true;
  }

  const queryVariations = normalizeTextForSearch(trimmed.toLowerCase());

  return (terms: string[]) =>
    terms.some((term) => {
      if (!term) {
        return false;
      }
      const termVariations = normalizeTextForSearch(term.toLowerCase());
      return queryVariations.some((variation) =>
        termVariations.some((termVariation) => termVariation.includes(variation))
      );
    });
};
